import React, { useEffect } from "react";

import * as visavail from "visavail";

import "visavail/visavail.css";
import { getUptimeBrightRiver } from "./lib/data";

const MonitoringIndex = () => {
    useEffect(() => {
        async function fetchData() {
            const dataset = await getUptimeBrightRiver();
            const options = {
                id_div_container: "visavail_container",
                id_div_graph: "visavail_graph",

                icon: {
                    class_has_data: "fas fa-fw fa-check",
                    class_has_no_data: "fas fa-fw fa-exclamation-circle",
                },
            };

            visavail.generate(options, dataset);
        }
        fetchData();
    }, []);

    return (
        <div>
            <h1>Monitoring</h1>
            <div className="visavail" id="visavail_container">
                <p id="visavail_graph"></p>
            </div>
        </div>
    );
};

export default MonitoringIndex;
